//所有带有样式配置挂件的组件文件
import { basic_button_create_style_obj } from '@/widgets/basic_button/patternStyle.js';
//import { basic_navbar_create_style_obj } from '@/widgets/basic_navbar/patternStyle.js';
import { basic_navbar_create_style_obj } from '@/widgets/basic_navbar/patternStyleClear.js';
import { basic_searchs_create_style_obj } from '@/widgets/basic_searchs/patternStyle.js';
export default {
  basic_button:basic_button_create_style_obj,
  basic_navbar:basic_navbar_create_style_obj,
  basic_searchs:basic_searchs_create_style_obj,


}



// WEBPACK FOOTER //
// ./src/base/complex_style_list.js